import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { TrackPagesOnOrderNewCardsModal } from '@/features/orderNewCards/types';

export const RFID_FLOW_NAME = 'rfid_card_order';

const debugConfig = createDebugConfig();

// Entry points tracking
export const trackOrderEntryPoint = (source: TrackPagesOnOrderNewCardsModal) => {
    trackCustomEvent(
        'rfid_order_start',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            element_name: 'order_button',
            entry_point: source,
        },
        debugConfig
    );
};

// Step tracking
export const trackOrderStep = (
    stepNumber: number,
    stepName: string,
    action: 'view' | 'complete' | 'back',
    source: TrackPagesOnOrderNewCardsModal
) => {
    trackCustomEvent(
        'rfid_order_step',
        {
            trigger: action === 'view' ? 'visibility' : 'click',
            flow_name: RFID_FLOW_NAME,
            step_number: stepNumber,
            step_name: stepName,
            action: action,
            entry_point: source,
            timestamp: new Date().toISOString(),
        },
        debugConfig
    );
};

// Order completion tracking
export const trackOrderComplete = (numCards: number, hasCustomization: boolean) => {
    trackCustomEvent(
        'rfid_order_complete',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            cards_ordered: numCards,
            has_customization: hasCustomization,
        },
        debugConfig
    );
};

// Order error tracking
export const trackOrderError = (errorStep: number, errorType: string) => {
    trackCustomEvent(
        'rfid_order_error',
        {
            trigger: 'system',
            flow_name: RFID_FLOW_NAME,
            error_step: errorStep,
            error_type: errorType,
        },
        debugConfig
    );
};

// Abandonment tracking
export const trackOrderAbandon = (currentStep: number, stepName: string, source: TrackPagesOnOrderNewCardsModal) => {
    trackCustomEvent(
        'rfid_order_abandon',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            step_number: currentStep,
            step_name: stepName,
            entry_point: source,
            timestamp: new Date().toISOString(),
        },
        debugConfig
    );
};
